module.exports = __webpack_public_path__ + "static/media/banner.ac9eb681.png";